import type { QueryKey } from '@tanstack/react-query';

import { get } from '../../../redux/api';
import { useQuery } from '../../../ReactQuery';
import type { ServiceStatusResponse } from '../../../../shared/services/types';
import type { VCSHost } from '../../../../shared/projectsV2/vcs';

function fetchServiceStatus(service: VCSHost) {
  return get<ServiceStatusResponse>(`/api/services/${service}/status`);
}

function getQueryKey(service: VCSHost): QueryKey {
  return ['services', service, 'status'];
}

/**
 * Get the status of an integration service (such as the GitHub App).
 * @param service Identifier of the service (like 'github-app')
 * @returns A ServiceStatusResponse containing the connection status
 */
export default function useServiceStatus(service: VCSHost) {
  return useQuery<ServiceStatusResponse>({
    queryKey: getQueryKey(service),
    queryFn: () => fetchServiceStatus(service),
  });
}
